// extracted by mini-css-extract-plugin
export default {"h-48":"cV6RoA","h-56":"T2Hmcr","h-64":"xvKyrc","root":"MtxYRY"};